@import '~style-sheet-helpers/core';
@import '../../../app-brand/entities/entity-layer.module.less';

.tooltip-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: @hotkey-tooltip--background-color;
  color: @hotkey-tooltip--text-color;
  padding: 10px 25px;
  border-radius: 30px;
  display: flex;
  align-items: center;

  .display-icon {
    color: @hotkey-tooltip--fill-color;
    height: 20px;
    width: auto;
    margin-right: 10px;
  }

  .hotkeys-pressed {
    margin-right: 5px;
  }
}
